import { useTranslation } from "react-i18next";

import { IBankChoice } from "../../../utils/contactDuplicates";

interface BankDetailsChoiceProps {
  choices: IBankChoice[];
  selectedId: string | null;
  onSelect: (accountId: string) => void;
}

// Which set of bank details survives an account merge, when the accounts disagree. New leads for this
// person are paid to the set kept; the others go into the kept account's notes, masked.
export default function BankDetailsChoice({ choices, selectedId, onSelect }: BankDetailsChoiceProps) {
  const { t } = useTranslation("accounts");

  return (
    <fieldset>
      <legend className="font-medium">{t("These accounts have different bank details. Which should the kept account have?")}</legend>
      <div className="mt-2 space-y-1">
        {choices.map((choice) => (
          <label key={choice.accountId} className="flex cursor-pointer items-center gap-2">
            <input
              type="radio"
              name="merge-bank-details"
              checked={choice.accountId === selectedId}
              onChange={() => onSelect(choice.accountId)}
            />
            <span>
              <span className="font-medium">#{choice.accountNumber}</span> {choice.bankDetails}
            </span>
          </label>
        ))}
      </div>
      <p className="mt-2">{t("New leads for this person are paid to the details kept. The others are written into the account's notes.")}</p>
    </fieldset>
  );
}
